// extracted by mini-css-extract-plugin
module.exports = {"container":"read-more_container__3i2tl","text":"read-more_text__aPtGq"};